const translations = {
    address1: 'Address 1',
    address2: 'Address 2',
    address2Max: 'Address Line 2 cannot exceed {{charMax}} characters',
    addressMax: 'Address cannot exceed {{charMax}} characters',
    cancel: 'Cancel',
    city: 'City',
    cityMax: 'City cannot exceed {{charMax}} characters',
    companyName: 'Company Name',
    nameMax: 'Company Name cannot exceed {{charMax}} characters',
    phone: 'Phone',
    save: 'Save',
    saveError: 'Company details could not be saved.',
    saving: 'Saving…',
    state: 'State',
    statePlaceholder: 'Select a state',
    title: 'Edit Company Details',
    zip: 'Zip'
};

export default translations;
